import React from "react"

export const SlidersIcon = ({ color = "#034055", size = 1, className }) => {
  return (
    <svg
      className={className}
      width={size * 24}
      height={size * 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <g>
          <path d="M0 0h24v24H0z" />
          <g stroke={color} strokeWidth="2.5">
            <path d="M0 4.5h24M0 12.5h24M0 20.5h24" />
          </g>
          <rect
            stroke={color}
            strokeWidth="2"
            fill="#F2F6F8"
            x="5"
            y="10"
            width="5"
            height="5"
            rx="2.5"
          />
          <rect
            stroke={color}
            strokeWidth="2"
            fill="#F2F6F8"
            x="14"
            y="18"
            width="5"
            height="5"
            rx="2.5"
          />
          <rect
            stroke={color}
            strokeWidth="2"
            fill="#F2F6F8"
            x="14"
            y="2"
            width="5"
            height="5"
            rx="2.5"
          />
        </g>
      </g>
    </svg>
  )
}
